export default __webpack_public_path__ + "static/media/double-caret.b0fb613d.svg";